<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>微软Word的Trinka
                            <br />插件
                            <span>仅限高级版</span>
                        </h1>
                        <p>微软Word的Trinka插件使有效的写作变得前所未有的简单！Trinka会自动检查您的写作，并在您熟悉的Word应用程序中进行修改。</p>
                        <div id="MacMSWordButton">
                            <button title="Word plugin coming soon for Mac OS">
                                <img src="assets/images/safari_logo.png" alt="">
                                即将推出
                            </button>
                            <span><a href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank">*适用于 Windows 上的 Microsoft Word 2010 及更高版本</a></span>
                        </div>
                        <div class="wordPluginCTA" id="MSWindowDownloadButton">
                            <b id="windowInfo64bit"></b>
                            <i class="">Beta</i>
                        </div>
                        <!-- <a> <img src="assets/images/whitePaper_download.png" alt=""> 现在下载</a> -->
                        <span id="MSWindowTextContent">*与Windows系统Word 2010以上版本相容</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/MSWordBanner.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>工作原理</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/DownloadTrackChangesEdit.svg" alt="" style="width: 50px; height: 50px;">
                                </div>
                                <h3>下载</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="" style="width: 36px; height: 45px;">
                                </div>
                                <h3>安装</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="" style="    width: 36px;  height: 46px;">
                                </div>
                                <h3>开始更好的写作</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="accomplishSections_img">

                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="assets/images/microsoft-wordThumbnails.jpg" alt="" class="img-fluid eposter-img">
                            <!-- <img src="https://i.ytimg.com/vi/uNNpxOtvJ80/maxresdefault.jpg" alt=""> -->
                        </a>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="spellcheck_heading EnhancementsHeadingSection">
                        <h2>
                            在Windows操作系统上开始使用Word的Trinka插件
                        </h2>
                        <div class="HeadingSubLine"></div>
                        <p>需要帮助安装插件吗？或者想知道怎么使用这个插件更正您的写作？
                        </p>
                        <p>
                            您可以立即查看简单的演练视频。
                        </p>
            <p>如果您还有更多问题，请<a (click)="scroll(target)" class="link">在此处</a>浏览我们的常见问题解答。

                <!-- <a (click)="scroll(target)" class="link">here</a>. -->
            </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Trinka Microsoft Word插件的主要功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>您可以在熟悉的MS Word应用程序中外挂Trinka，在写作的同时获得更正和建议。更棒的是它会自动检查所有更改，因此您不会错过任何内容！</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/style_guide_icon.svg" alt="">
                        <h3>风格指南设定</h3>
                        <p>根据常用的学术风格指南（AMA第11版、AGU 2017等等）调整手稿的语法和单词选择。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>专业领域和文档类型</h3>
                        <p>根据专业领域和文档类型定制Trinka，为您提供最相关的建议。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/AddtoDictionary.svg" alt="">
                        <h3>添加到词典</h3>
                        <p>将自己的单词添加到“我的词典”中，这样Trinka就不会在将来的写作中将其标记为拼写错误。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/DataSecurityIcon.svg" alt="">
                        <h3>数据安全</h3>
                        <p>您输入的任何内容都会被安全地传输和分析，我们决不会保留您的数据。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="assets/images/sendForHumanEditing.svg" alt="">
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>发送进行人工编辑</h3>
                        <p>需要专家为您的最终稿件进行人工编辑吗？直接从Trinka编辑工具将其发送给英论阁的专家进行编辑。</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常见问答</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        请问如何为微软Word添加/安装Trinka插件？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在微软Word的Trinka插件页面上，您可以找到“立即下载”按钮。下载安装文件后，双击它开始安装过程，安装成功后打开微软Word应用程序。您在顶部的功能区上可以找到一个名为Trinka的新选项卡。单击选项卡并点击”登录”，使用您的高级帐户登录就开始使用Trinka了。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">如何在Word中打开Trinka语法检查功能？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>下载并安装微软Word的Trinka插件后，您只需要使用您的Trinka帐户凭据登录，然后单击功能区菜单上Trinka选项卡上的“开始”按钮即可开始Trinka语法检查。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        在微软Word上安装Trinka插件的系统要求是什么？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>微软Word的Trinka插件适用于Windows上的微软Word 2010及更高版本，Mac版微软 Word插件即将推出。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以在Mac上使用微软Word的Trinka插件吗？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Mac上的微软Word插件正在开发中，即将推出。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        微软Word的Trinka插件是否实时检查拼写和语法？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，微软Word的Trinka插件会实时检查并提出更正建议。此外，它会检测您所做的任何更改，并立即重新检查您的写作并进行更正。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        如何接受或拒绝建议？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>接受或拒绝建议非常容易。只需单击建议的单词就可以接受或者应用更正，或单击“拇指向下”的这个图标就可以拒绝建议。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        我可以在微软Word的Trinka插件里面选择在美国英语和英国英语之间进行切换吗？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。您可以从功能区菜单上的语言检查和设置菜单选项里面，选择在美国英语和英国英语之间进行切换。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        在微软Word的Trinka插件中，我可以选择格式指南吗？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。您可以从功能区菜单上的语言检查和设置菜单选项中选择首选格式指南。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        我没有安装微软Word，而是使用Google Docs、Medium等在线写作，那么该如何使用Trinka？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在您喜爱的网站上，您可以使用我们开发的适用于Chrome、Firefox和Edge浏览器的Trinka浏览器插件，
                                            <a href="/browser-plugin">点击这里</a>下载浏览器的Trinka插件。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        安装成功后找不到Word的Trinka插件怎么办？
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在某些情况下，您的系统/单位安全可以禁用加载项的激活。您可以尝试从文件->选项->加载项->管理->COM-加载项来手动启用它。您可以
                                            <a href="https://youtu.be/RDrzQOBNAsk" target="_blank">观看此视频</a>以了解详细的流程。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        如果微软Word的Trinka插件无法检测到写作错误，那该怎么办？
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以尝试以下几个步骤来解决问题：</p>
                                        <ul>
                                            <li>请检查您的互联网连接。您需要连接到互联网才能让Trinka检测错误并提出更正建议。</li>
                                            <li>检查插件是否因为您的系统/单位的安全设置而被禁用。
                                            </li>
                                            <li>尝试卸载并重新安装插件。</li>
                                            <li>如果问题仍然存在，请发送电子邮件至
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a>，我们的团队将帮助您解决问题。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <div class="app_name_content" routerLink="/trinkacloud">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                        <h3>
                                            <span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>

                                    </div>
                                </li>
                                <!-- <li>
                                    <div class="app_name_content" routerLink="/wordplugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Others_App_MSWord.svg" alt="">
                                        <h3><span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span><br />插件</h3>

                                    </div>
                                </li> -->
                                <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/other_Apps_browser.svg" alt="">
                                        <h3>浏览器插件</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                        <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                        <span class="OpenSansFonts" style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="//player.bilibili.com/player.html?aid=343526657&bvid=BV1a94y1Q779&cid=776611145&page=1"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>